export const metropolis = "74117920305567";
export const whitelistedBusinessIds = [metropolis];
export const doctorWhitelisted = ["170296242226562", "169771037272264"];

export const isBusinessWhitelisted = ({
  businessId,
}: {
  businessId: string;
}) => {
  return whitelistedBusinessIds.includes(businessId);
};

export const isDoctorAdminInWhitelistedBusiness = ({
  oid,
  businessId,
}: {
  oid: string;
  businessId: string;
}) => {
  return (
    doctorWhitelisted.includes(oid) && isBusinessWhitelisted({ businessId })
  );
};
